const __WEBPACK_NAMESPACE_OBJECT__ = window["__ROCKY_GSAP__"];